import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import errorReportsApi from '../services/errorReportsApi';
import { formatApiError } from '../utils/errorMessage';

function shownTime(value) {
  if (!value) return '';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return '';
  return parsed.toLocaleString();
}

const ErrorReports = () => {
  const { user } = useAuth();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const canView = user && (user.is_superuser || user.role === 'superuser' || user.platform_role === 'superuser');

  const load = async () => {
    try {
      setLoading(true);
      const res = await errorReportsApi.list();
      setRows(res.data || []);
      setError('');
    } catch (loadError) {
      setError(formatApiError(loadError, 'Failed to load error reports'));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (canView) load();
  }, [canView]);

  const acknowledge = async (id) => {
    try {
      await errorReportsApi.acknowledge(id);
      await load();
    } catch (ackError) {
      setError(formatApiError(ackError, 'Failed to acknowledge'));
    }
  };

  if (!canView) {
    return <p>Superuser required</p>;
  }

  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold mb-4">Error reports</h1>
      {error && <p className="text-red-600 mb-4" role="alert">{error}</p>}
      {loading ? <p>Loading</p> : (
        <table className="min-w-full border">
          <thead>
            <tr>
              <th className="border px-2 py-1 text-left">Environment</th>
              <th className="border px-2 py-1 text-left">Surface</th>
              <th className="border px-2 py-1 text-left">Workflow</th>
              <th className="border px-2 py-1 text-left">Where</th>
              <th className="border px-2 py-1 text-left">Release</th>
              <th className="border px-2 py-1 text-left">First seen</th>
              <th className="border px-2 py-1 text-left">Last seen</th>
              <th className="border px-2 py-1 text-left">Message</th>
              <th className="border px-2 py-1 text-left">Count</th>
              <th className="border px-2 py-1 text-left">Acknowledge</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.id}>
                <td className="border px-2 py-1">{row.environment}</td>
                <td className="border px-2 py-1">{row.surface}</td>
                <td className="border px-2 py-1">{row.workflow}</td>
                <td className="border px-2 py-1">{row.top_frame}</td>
                <td className="border px-2 py-1">{row.release}</td>
                <td className="border px-2 py-1">{shownTime(row.first_seen_at)}</td>
                <td className="border px-2 py-1">{shownTime(row.last_seen_at)}</td>
                <td className="border px-2 py-1">{row.message}</td>
                <td className="border px-2 py-1">{row.count}</td>
                <td className="border px-2 py-1">
                  {row.acknowledged_at ? 'Acknowledged' : (
                    <button type="button" onClick={() => acknowledge(row.id)}>Acknowledge</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ErrorReports;
